import React, { FC, useContext } from "react";
import { ThemeContext } from "styled-components";
import { MobileMenuIcon } from "../../MobileMenuIcon";
import { InternalLink } from "../../../links/InternalLink";
import { NavigationLink } from "..";
import { colors } from "../../../../styles/variables";
import { StyledLink, StyledMenu, StyledMobileMenu } from "./index.styled";

interface MobileMenuProps {
  isMenuOpen: boolean;
  links: NavigationLink[];
  setMenuOpen: (isOpen: boolean) => void;
}

export const MobileMenu: FC<MobileMenuProps> = ({
  isMenuOpen,
  links,
  setMenuOpen,
}) => {
  const theme = useContext(ThemeContext);
  return (
    <StyledMobileMenu>
      <MobileMenuIcon
        isOpen={isMenuOpen}
        onClick={() => setMenuOpen(!isMenuOpen)}
        color={theme.header?.portal?.navLinkColor || colors.white}
      />
      <StyledMenu isMenuOpen={isMenuOpen}>
        {links?.map((link) => {
          const { position, title, url } = link;
          return (
            <InternalLink
              key={position}
              href={url}
              onClick={() => setMenuOpen(false)}
            >
              <StyledLink>{title}</StyledLink>
            </InternalLink>
          );
        })}
      </StyledMenu>
    </StyledMobileMenu>
  );
};
